var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertCheckGrn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00004 17.6667C13.7865 17.6667 17.6667 13.7865 17.6667 9.00004C17.6667 4.21357 13.7865 0.333374 9.00004 0.333374C4.21357 0.333374 0.333374 4.21357 0.333374 9.00004C0.333374 13.7865 4.21357 17.6667 9.00004 17.6667ZM14.4328 6.31964C14.5685 6.45676 14.6364 6.62325 14.6364 6.81914C14.6364 7.01502 14.5685 7.18151 14.4328 7.31863L8.17822 13.6357C8.04246 13.7729 7.87762 13.8414 7.68368 13.8414C7.48974 13.8414 7.32489 13.7729 7.18913 13.6357L3.56731 9.97769C3.43155 9.84058 3.36368 9.67408 3.36368 9.4782C3.36368 9.28232 3.43155 9.11582 3.56731 8.97871L4.5564 7.97972C4.69216 7.84261 4.85701 7.77405 5.05095 7.77405C5.24489 7.77405 5.40974 7.84261 5.54549 7.97972L7.68368 10.1466L12.4546 5.32066C12.5903 5.18354 12.7552 5.11498 12.9491 5.11498C13.1431 5.11498 13.3079 5.18354 13.4437 5.32066L14.4328 6.31964Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertCheckGrn);
export default __webpack_public_path__ + "static/media/ico_alert_check_grn.41fdcce9.svg";
export { ForwardRef as ReactComponent };